import React, { useEffect, useState } from 'react';
import MDEditor from '@uiw/react-md-editor';
import rehypeSanitize from 'rehype-sanitize';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useController } from 'react-hook-form';
import classNames from 'classnames';
import './MarkDownEditor.scss';

const propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  limit: PropTypes.number,
};
const defaultProps = {
  disabled: false,
  label: '',
  placeholder: '',
  limit: -1,
};

export function MarkDownEditor(props) {
  const { label, name, disabled, placeholder, limit } = props;
  const [value, setValue] = useState('');
  const [strLen, setStrLen] = useState(value.length);
  const { field, formState } = useController(props);
  const [textareaId, setTextareaId] = useState(
    `md-editor-${new Date().getTime()}`
  );
  const onChanged = (e) => {
    setStrLen(e.target.value.length);
  };

  const checkIfErrorsExists = (obj) =>
    !!(obj && obj.errors[name] && Object.keys(obj.errors[name]).length);

  const editorComponent = () => (
    <div data-color-mode="light">
      <MDEditor
        aria-disabled={disabled}
        value={value}
        onChange={setValue}
        previewOptions={{
          rehypePlugins: [[rehypeSanitize]],
        }}
        textareaProps={{
          placeholder: placeholder.length > 0 ? placeholder : label,
          disabled,
          maxLength: limit,
          onChange: onChanged,
          id: textareaId,
        }}
        preview="edit"
        name={name}
        {...field}
        className={classNames({
          'form-control p-0 is-invalid ': checkIfErrorsExists(formState),
        })}
      />
    </div>
  );
  useEffect(() => {
    setTextareaId(`md-editor-${new Date().getTime()}`);
    setStrLen(document.querySelector(`#${textareaId}`).value.length);
  }, []);
  return (
    <div className="form markdown-editor mb-3 mb-3">
      {label.length > 0 ? (
        <Row>
          <Col sm={12} xl={3} md={3} className="label-container">
            <label htmlFor="formTextArea" className="col-form-label">
              {label}
            </label>
          </Col>
          <Col sm={12} xl={9} md={9} className="field-container">
            {editorComponent()}
            <div
              className={classNames('invalid-feedback', {
                show: checkIfErrorsExists(formState),
              })}
            >
              {formState.errors[name]?.type === 'required' &&
                `${label} is required`}
            </div>
            {limit > 0 && (
              <p
                className={`small mt-2 p-2 ${
                  strLen === limit ? 'text-danger' : 'text-muted'
                }`}
              >
                <strong>{strLen}</strong> characters out of{' '}
                <strong>{limit}</strong> max characters
              </p>
            )}
          </Col>
        </Row>
      ) : (
        editorComponent()
      )}
    </div>
  );
}

MarkDownEditor.propTypes = propTypes;
MarkDownEditor.defaultProps = defaultProps;
